import { BaseHead, CellOfRow, Sort } from '@components/tables';
import { Paging } from '@Core';
import { ContraventionAuditEvent, ContraventionAuditEventEntityName } from '@EcamModel/model/ContraventionAuditEvent';
import {
    Box,
    Stack,
    Table,
    TableBody,
    TableContainer,
    TableHead,
    TableRow,
    Typography
} from '@mui/material';
import ListNoData from '@pages/cameras/list/components/NoDataCameras';
import { OwnFilter } from '@pages/overview/components/CancellationReasons';
import { formatUKDateTime } from 'src/helpers';
import { verificationEventLogType, verificationNotesEventLogType } from '../configs';
import { formatEnumValue } from '../helpers';
import SkeletonEventLogTable from './SkeletonEventLogTable';

type EventLogTableProps = {
    trailAuditEventLogPCN?: Paging<ContraventionAuditEvent>;
    isLoading: boolean;
    filterSortState: OwnFilter;
    handleSortChange: (sort: Sort) => void;
};

export default function ListEventLogTable(props: EventLogTableProps) {
    const { trailAuditEventLogPCN, isLoading, filterSortState, handleSortChange } = props;

    return (
        <TableContainer component={Box}>
            {isLoading ? (
                <SkeletonEventLogTable
                    rows={4}
                    columns={4}
                    skeletonWidths={[100, 100, 100, 300]}
                    nestedSkeletonWidths={[400, 400]}
                />
            ) : trailAuditEventLogPCN?.rows?.length! > 0 ? (
                <Table aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <BaseHead
                                align="left"
                                title="Date/time"
                                isLeftLabel
                                sx={{
                                    justifyContent: 'flex-start',
                                    alignItems: 'start',
                                }}
                                sort={
                                    isLoading
                                        ? undefined
                                        : filterSortState.sorts?.includes('-Updated')
                                        ? 'DSC'
                                        : filterSortState.sorts?.includes('Updated')
                                        ? 'ASC'
                                        : undefined
                                }
                                onChangeSort={handleSortChange}
                            />
                            <BaseHead align="left" title="User" />
                            <BaseHead align="left" title="Type" />
                            <BaseHead align="left" title="Details" />
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {trailAuditEventLogPCN?.rows?.map((item, index) => {
                            return (
                                <TableRow key={index}>
                                    <CellOfRow value={formatUKDateTime(item.Created)} align="left" />
                                    <CellOfRow value={item.UpdatedBy ?? ''} align="left" />
                                    <CellOfRow
                                        value={`${formatEnumValue({
                                            enumKey: item.AuditEventType,
                                            enumMapping:
                                                item.EntityName === ContraventionAuditEventEntityName.VerificationNotes
                                                    ? verificationNotesEventLogType
                                                    : verificationEventLogType,
                                            capitalizeFirstLetter: true,
                                        })}`}
                                        align="left"
                                    />
                                    <CellOfRow
                                        value={
                                            <Stack>
                                                <Typography>
                                                    {item.UpdatedBy ?? ''}{' '}
                                                    {formatEnumValue({
                                                        enumKey: item.AuditEventType,
                                                        enumMapping:
                                                            item.EntityName ===
                                                            ContraventionAuditEventEntityName.VerificationNotes
                                                                ? verificationNotesEventLogType
                                                                : verificationEventLogType,
                                                        capitalizeFirstLetter: false,
                                                    })}
                                                    {/*{formatEnumValue({
                                                        enumKey: item.EntityName,
                                                        enumMapping: verificationEventLogAuditEventEntityName,
                                                        capitalizeFirstLetter: false,
                                                    })} */}
                                                    :
                                                </Typography>
                                                <ul
                                                    style={{
                                                        marginTop: '4px',
                                                        marginBottom: '4px',
                                                    }}
                                                >
                                                    <li>
                                                        <Typography
                                                            sx={{
                                                                whiteSpace: 'pre-wrap',
                                                            }}
                                                        >
                                                            {item.Notes}
                                                        </Typography>
                                                    </li>
                                                </ul>
                                            </Stack>
                                        }
                                        align="left"
                                    />
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            ) : (
                <ListNoData />
            )}
        </TableContainer>
    );
}
